// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gR2E","colMin":"styles_colMin__3AaLf"};